export enum RoutesEnum {
  Accreditor = 'accreditor',
  Institution = 'institution'
}
